<template>
  <div class="page">
    <header class="topbar">
      <AppLogo asLink to="/" :height="22" />
      <button
        class="mobile-menu-btn"
        @click="isMobileMenuOpen = !isMobileMenuOpen"
      >
        ☰
      </button>
    </header>

    <!-- 모바일 메뉴 추가 (main 태그 앞이나 안에) -->
    <div class="mobile-menu" :class="{ active: isMobileMenuOpen }">
      <div class="mobile-menu-overlay" @click="isMobileMenuOpen = false"></div>
      <div class="mobile-menu-content">
        <MemberInfoCard :user="memberCard" />
        <AppSideMenu
          @logout="logout"
          @menu-click="isMobileMenuOpen = false"
          style="margin-top: 16px"
        />
      </div>
    </div>

    <main class="grid">
      <section class="left">
        <MemberInfoCard :user="memberCard" />
        <AppSideMenu @logout="logout" style="margin-top: 16px" v-once />
      </section>

      <section class="center">
        <router-view />
      </section>
    </main>
  </div>
</template>

<script>
import AppLogo from "@/components/AppLogo.vue";
import MemberInfoCard from "@/components/MemberInfoCard.vue";
import AppSideMenu from "@/components/AppSideMenu.vue";
import { apiJson, api } from "@/lib/api";
import { clearSession } from "@/lib/session";

export default {
  name: "MainLayout",
  components: {
    AppLogo,
    MemberInfoCard,
    AppSideMenu,
  },
  data() {
    return {
      isMobileMenuOpen: false,
      memberCard: {
        name: "-",
        membership: "-",
        expiredAt: "-",
        remaining: "-",
      },
    };
  },
  created() {
    this.loadMemberCard();
  },
  methods: {
    async loadMemberCard() {
      try {
        const s = await apiJson("/v1/me/summary");
        this.memberCard = s;
      } catch (e) {
        console.error("Failed to load member card:", e);
      }
    },
    async logout() {
      try {
        await api("/v1/auth/sessions", { method: "DELETE" });
      } catch (e) {
        console.error("Logout failed:", e);
      }
      clearSession();
      this.$router.replace("/signin");
    },
  },
};
</script>

<style scoped>
.page {
  --gutter-left: 88px;
  min-height: 100vh;
  background: #000;
  color: #fff;
}

.topbar {
  height: 70px;
  display: flex;
  align-items: center;
  padding: 0 24px 0 var(--gutter-left);
}

.grid {
  display: grid;
  grid-template-columns: 280px 1fr;
  gap: 24px;
  width: 100%;
  margin: 24px 0 64px;
  padding: 0 16px 0 var(--gutter-left);
  box-sizing: border-box;
}

.left {
  display: grid;
  gap: 16px;
  align-self: start;
}

.center {
  display: flex;
  flex-direction: column;
}

.footer-bar {
  width: 100%;
  padding: 12px 16px;
  background: #151718;
}

.hint {
  color: #8e8e8e;
  font-size: 14px;
}

@media (max-width: 1100px) {
  .grid {
    grid-template-columns: 1fr;
  }
}

.mobile-menu-btn {
  display: none;
  margin-left: auto;
  background: none;
  border: none;
  color: #fff;
  font-size: 24px;
  cursor: pointer;
}

.mobile-menu {
  display: none;
}

@media (max-width: 1100px) {
  .mobile-menu-btn {
    display: block;
  }

  .page {
    --gutter-left: 0; /* 모바일에서 왼쪽 여백 제거 */
  }

  .left {
    display: none;
  }

  .mobile-menu {
    display: block;
    position: fixed;
    top: 70px;
    left: 0;
    right: 0;
    bottom: 0;
    pointer-events: none;
    z-index: 1000;
  }

  .mobile-menu.active {
    pointer-events: all;
  }

  .mobile-menu-overlay {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.5);
    opacity: 0;
    transition: opacity 0.3s;
  }

  .mobile-menu.active .mobile-menu-overlay {
    opacity: 1;
  }

  .close-btn {
    position: absolute;
    top: 16px;
    right: 16px;
    background: none;
    border: none;
    color: #fff;
    font-size: 28px;
    cursor: pointer;
    padding: 4px;
    line-height: 1;
  }

  .mobile-menu-content {
    position: absolute;
    top: 0;
    right: 0;
    width: 320px;
    max-width: 80%;
    height: 100%;
    background: #000;
    padding: 24px 16px;
    transform: translateX(100%);
    transition: transform 0.3s;
    overflow-y: auto;
  }

  .mobile-menu.active .mobile-menu-content {
    transform: translateX(0);
  }
}
</style>
